import React from 'react';
import "./Style.css"
import Contact from './Contact';

const About: React.FC = () => {

  return (
    <div className="body">
      <br></br>
      <hr className="custom-line" />
      <div className="body text-container">
        <p>Salut! Sunt Claudiu, un tânăr pasionat de artă, din Cluj Napoca. </p>
        <p>Folosind o gamă variată de tehnici și materiale, creez tablouri unice, pline de emoție și culoare. Fie că vorbim despre peisaje, portrete sau abstracte, fiecare lucrare este realizată cu atenție la detalii și cu un strop de inspirație din lumea din jurul meu. Tablourile sunt realizate la comandă, dar unele dintre creațiile mele sunt disponibile pentru a fi admirate și achiziționate chiar acum. Te invit să explorezi portofoliul meu și să descoperi câteva dintre modelele ce îți pot transforma spațiul cu adevărat.</p>
        <p>Livrez oriunde în țară.</p>
        <Contact />
      </div>
    </div>
  );
};

export default About;
